@switch (tradeRoute) {
  @case (ROUTES.CREATE) {
    <trade-create [isin]="isin" [useCache]="useCache" (goNext)="changeRoute(ROUTES.CONFIRM)" />
  }
  @case (ROUTES.CONFIRM) {
    <trade-confirm (goBack)="changeRoute(ROUTES.CREATE, true)" (goNext)="changeRoute(ROUTES.SUCCESS)" />
  }
  @case (ROUTES.SUCCESS) {
    <trade-success (goInit)="initTradeForm($event)" />
  }
}
